/**
 * Quote component
 */

import React from "react"
import parse from "html-react-parser"
import { kebabCase } from "lodash"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa"

const Quote = ({ props, annualReport }) => {
  const { includeInStickyMenu } = props
  const backgroundColor = annualReport === "2024" ? props?.backgroundColorAr24 : props?.backgroundColor
  const additionalQuotes = props?.additionalQuotes || []
  const quotes = [
    {
      quote: props.quote,
      citation: props.citation,
      citationUrl: props.citationUrl,
      citationDescription: props.citationDescription,
      image: props.image,
    },
    ...additionalQuotes,
  ]

  const quoteCount = quotes.length
  return (
    <section
      className={`section relative print:bg-transparent 
      
      ${!backgroundColor || backgroundColor === "transparent" ? "m-section" :
          annualReport === "2024" ? `p-section overflow-clip`
            : annualReport === "2023" ?
              `p-section bg-cover ${(backgroundColor === "transparent" ? ""
                : backgroundColor === "blue-100" ? "bg-blue-blobs"
                  : backgroundColor === "green-100" ? "bg-green-blobs"
                    : backgroundColor === "teal" ? "bg-teal-blobs"
                      : "")}`
              : "bg-gradient-to-b mb-section pt-section print:from-transparent " +
              (backgroundColor === "blue-100"
                ? "from-blue-300 "
                : backgroundColor === "green-100"
                  ? "from-green-300"
                  : backgroundColor === "teal"
                    ? "from-teal-200"
                    : "")
        }`}
      key={
        includeInStickyMenu?.menuTitle || (quotes && quotes[0] ? kebabCase(quotes[0].quote) : "") || ""
      }
      id={`${kebabCase(includeInStickyMenu?.menuTitle) || ""}`}
    >
      {annualReport === "2024" ? (
        <div className={`absolute bg-cover -inset-10 overflow-clip ${(backgroundColor === "transparent" ? ""
          : backgroundColor === "tealBlur" ? "bg-circles-teal blur-2xl transform scale-x-110"
            : backgroundColor === "mixedBlueBlur" ? "bg-circles-blue  blur-2xl transform scale-x-110"
              : backgroundColor === "blueBlur" ? "bg-circles-only-blue  blur-2xl transform scale-x-110"
                : backgroundColor === "tealCircles" ? "bg-circles-page-teal"
                  : "")} print:hidden`} aria-hidden />
      ) : null}
      <div className={`sm:container ${quoteCount > 1 ? "grid lg:grid-cols-2 gap-12 xl:gap-20" : ""}`}>
        {quotes?.map((singleQuote, index) => {
          return <SingleQuote quoteCount={quoteCount} props={singleQuote} index={index} annualReport={annualReport} />
        })}
      </div>
    </section>
  )
}

export default Quote

function SingleQuote({ quoteCount, props, index, annualReport }) {
  const { quote, citation, citationUrl, citationDescription } = props
  const image = {
    src: props.image?.localFile ? getImage(props.image?.localFile) : null,
    alt: props.image?.altText || props?.citation || "",
  }
  return <div className={`relative ${annualReport === "2024" ? "flex items-stretch bg-white rounded-lg p-2 sm:p-4 mx-2 sm:mx-0" : quoteCount > 1 ? "bg-gray-50/50 py-12 px-6 flex items-end" : "lg:w-2/3 mx-auto"}`}>
    <div className={`flex justify-center ${annualReport === "2024" ? "border border-blue-500 rounded-md p-4" : ""}`}>
      {annualReport === "2024" ? null : <FaQuoteLeft
        className={`flex-shrink-0 text-lg text-gray-800 text-opacity-10
        ${quoteCount > 1 ? "sm:text-3xl" : "sm:text-4xl"} mr-4`}
        aria-hidden />}
      <div className={`${annualReport === "2024" ? "flex flex-col justify-between" : ""}`}>
        {quote ? (
          <blockquote
            className={`parsed-content ${annualReport === "2024" ? "" : `text-lg ${quoteCount > 1 ? `lg:text-xl` : " md:text-xl 2xl:text-2xl"}`}`}
            cite={citationUrl ? citationUrl : ""}
          >
            {parse(quote)}
          </blockquote>
        ) : null}
        <div
          className={`mt-6 ${quoteCount > 1 ? "" : "text-center"}`}
        >
          {image?.src && (
            <GatsbyImage
              className={`rounded-full h-24 w-24`}
              image={image.src}
              alt={image.alt} />
          )}
          {citation ? (
            <div
              className={`${annualReport === "2024" ? "text-sm font-bold" : `text-lg`} mt-4`}
              id={kebabCase(citation)}
            >
              {citation}
            </div>
          ) : null}
          {citationDescription ? (
            <div
              className={`mt-1 ${annualReport === "2024" ? "text-sm" : ""}`}
              id={kebabCase(citationDescription)}
            >
              {citationDescription}
            </div>
          ) : null}
        </div>
      </div>
      {annualReport === "2024" ? null : <FaQuoteRight
        className={`flex-shrink-0 text-lg text-gray-800 text-opacity-10
        ${quoteCount > 1 ? "sm:text-3xl" : "sm:text-4xl"} ml-4`}
        aria-hidden />}
    </div>
  </div>
}

